import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackgroundScene from "../../components/BackgroundScene";
import SEO from "../../components/SEO";
import { buildCanonicalUrl } from "../../utils/basePath";
import styles from "./Home.module.css";
import MainHero from "../../components/MainHero";
import ServerInstalls from "../../components/ServerInstalls";
import FeatureSection from "../../components/FeatureSection";
import ComingSoon from "../../components/ComingSoon";

interface HomeProps {}

const Home: React.FC<HomeProps> = () => {
  return (
    <div className={styles.home}>
      <SEO
        title="Rythm - Discord Music Bot Made for Listening Together"
        description="The music app designed to be used together. Rythm makes it possible to share, discover and enjoy music with friends from all around the world."
        keywords="rythm bot, discord music bot, play music on discord, listen with friends, music streaming discord, music bot 2025, group listening, best discord music bot, rythm music app, playlist discord"
        canonicalUrl={buildCanonicalUrl("/")}
        ogImage="https://rythm.fm/assets/images/main-og.png"
        ogImageAlt="Rythm - The best Discord music bot for listening together with friends"
        schemaType="SoftwareApplication"
      />
      <ComingSoon />

    </div>
  );
};

export default Home;
